import { ADD_ENVIRONMENT_WIZARD_TYPE } from "../addEnvironment/constants";
import { CONSENT_MANAGER_WIZARD_TYPE } from "../consentManager/constants";
import { CONVERSION_EVENTS_WIZARD_TYPE } from "../conversionEvents/constants";
import { ENABLE_DESTINATION_WIZARD_TYPE } from "../enableDestination/constants";
import { WizardMascot } from "../framework/types";
import { INSTALL_SDK_WIZARD_TYPE } from "../installSdk/constants";
import { GlindaArt } from "./art/GlindaArt";
import { MerlinArt } from "./art/MerlinArt";
import { MorganLeFayArt } from "./art/MorganLeFayArt";
import { OzArt } from "./art/OzArt";
import { ProsperoArt } from "./art/ProsperoArt";

// Mascots are public-domain wizards drawn from the original texts, not from
// any film or franchise adaptation. Keep it that way when adding one.
export const wizardMascots = {
  [INSTALL_SDK_WIZARD_TYPE]: {
    name: "Oz, the Great and Terrible",
    tagline:
      "Works his magic from behind a screen, where your visitors never see the snippet.",
    Art: OzArt,
  },
  [ENABLE_DESTINATION_WIZARD_TYPE]: {
    name: "Glinda the Good",
    tagline: "Knows the road to every land, and sees your events safely there.",
    Art: GlindaArt,
  },
  [CONVERSION_EVENTS_WIZARD_TYPE]: {
    name: "Merlin",
    tagline:
      "Has seen how every story ends, and helps you choose the ending that counts.",
    Art: MerlinArt,
  },
  [CONSENT_MANAGER_WIZARD_TYPE]: {
    name: "Prospero",
    tagline: "Lays down his staff and lets the audience decide.",
    Art: ProsperoArt,
  },
  [ADD_ENVIRONMENT_WIZARD_TYPE]: {
    name: "Morgan le Fay",
    tagline:
      "Conjures a mirror of your world, so every spell can be tried before it’s real.",
    Art: MorganLeFayArt,
  },
} satisfies Record<string, WizardMascot>;
